module.exports = __webpack_public_path__ + "img/icon_agree.ec71c699.png";